import { render, staticRenderFns } from "./mobilePracticeExam.vue?vue&type=template&id=23ea18fa&scoped=true&"
import script from "./mobilePracticeExam.vue?vue&type=script&lang=js&"
export * from "./mobilePracticeExam.vue?vue&type=script&lang=js&"
import style0 from "./mobilePracticeExam.vue?vue&type=style&index=0&id=23ea18fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea18fa",
  null
  
)

export default component.exports